export enum RelationshipMutationTypes {
    SET_RELATIONSHIP_FAMILIES = 'SET_RELATIONSHIP_FAMILIES',
    SET_RELATIONSHIP_DOMESTICS = 'SET_RELATIONSHIP_DOMESTICS',
    SET_RELATIONSHIP_PARENTS = 'SET_RELATIONSHIP_PARENTS',
  }
  